module.exports = __webpack_public_path__ + "img/move-goout.3bafdd03.png";